/* staacked theme.js  -- vanilla, no deps */
(function () {
  "use strict";

  /* ---- header height -> --headh CSS var ----
     sticky offsets (the collection filterbar) and the header mega-panel's max-height
     track the REAL header height instead of a hardcoded 60px — on mobile the wrapped
     search row always made the header taller than the old constant. the mega-panel and
     facet panels are absolutely positioned, so they never feed back into offsetHeight. */
  var headEl = document.querySelector(".head");
  function setHeadH() {
    if (headEl) document.documentElement.style.setProperty("--headh", headEl.offsetHeight + "px");
  }
  setHeadH();
  window.addEventListener("load", setHeadH);
  var headHT;
  window.addEventListener("resize", function () { clearTimeout(headHT); headHT = setTimeout(setHeadH, 150); });

  /* ---- header shop-by-size mega-panel: close on outside click / escape / chip tap ---- */
  var headSizes = document.querySelector("[data-head-sizes]");
  if (headSizes) {
    document.addEventListener("click", function (e) {
      if (headSizes.hasAttribute("open") && !headSizes.contains(e.target)) headSizes.removeAttribute("open");
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && headSizes.hasAttribute("open")) {
        headSizes.removeAttribute("open");
        var s = headSizes.querySelector("summary");
        if (s) s.focus();
      }
    });
    headSizes.addEventListener("click", function (e) {
      if (e.target.closest("a.size-chip")) headSizes.removeAttribute("open"); // tidy before navigation
    });
  }

  /* ---- collection: auto-submit filters + sort ---- */
  var facetForm = document.querySelector("[data-facet-form]");
  if (facetForm) {
    facetForm.addEventListener("change", function (e) {
      if (e.target.matches("input, select")) {
        // close any open dropdowns then submit
        facetForm.submit();
      }
    });
    // price range submit on enter/blur
    facetForm.querySelectorAll("[data-price-input]").forEach(function (inp) {
      inp.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter") { ev.preventDefault(); facetForm.submit(); }
      });
    });
    // exclusive open: <details name="facets"> does this natively in 2024+ browsers;
    // this fallback covers older ones (two full-width panels would overlap otherwise)
    facetForm.querySelectorAll(".facet").forEach(function (d) {
      d.addEventListener("toggle", function () {
        if (!d.open) return;
        facetForm.querySelectorAll(".facet[open]").forEach(function (o) {
          if (o !== d) o.removeAttribute("open");
        });
      });
    });
  }

  // standalone sort dropdown (when outside the facet form)
  var sortSel = document.querySelector("[data-sort]");
  if (sortSel) {
    sortSel.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSel.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  }

  // close facet dropdowns when clicking elsewhere
  document.addEventListener("click", function (e) {
    document.querySelectorAll(".facet[open]").forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute("open");
    });
  });

  /* ---- size conversion + nested size filter ----
     the size option mixes 5 systems (apparel s/m/l/xl, adult men 7-15, women 8.5W,
     toddler/kid 4.5C, youth 6Y, combos 10.5M/12W). US shoe conversion: women = men + 1.5,
     youth (GS) runs on the men's scale. we parse every value to a canonical men's-scale
     number, bucket by age, and MERGE equivalent labels into one checkbox with a
     dual-system label ("6y / 7.5w") — one tap matches every equivalent raw value. */
  function staackedParseSize(raw) {
    var v = (raw || "").toLowerCase().trim();
    if (!v) return { bucket: "other", canon: null };
    if (/^(xxs|xs|s|m|l|xl|xxl|xxxl|os|o\/s|one size)$/.test(v)) return { bucket: "apparel", canon: null };
    if (v.indexOf("/") !== -1) v = v.split("/")[0].trim(); // combos already encode the pair
    var m = v.match(/^(\d{1,2}(?:\.\d)?)\s*([cywm]?)$/);
    if (!m) return { bucket: "other", canon: null };
    var n = parseFloat(m[1]), s = m[2];
    if (s === "c") return { bucket: n <= 10 ? "toddler" : "littlekid", canon: n, track: "c" };
    if (s === "y") return { bucket: "bigkid", canon: n, track: "us" };
    if (s === "w") { n = n - 1.5; return { bucket: n < 7 ? "bigkid" : "adult", canon: n, track: "us" }; }
    return { bucket: "adult", canon: n, track: "us" }; // bare number or m = men's scale
  }
  function staackedSizeLabel(bucket, n) {
    var f = function (x) { return (Math.round(x * 10) / 10).toString().replace(/\.0$/, ""); };
    if (bucket === "toddler" || bucket === "littlekid") return f(n) + "c";
    if (bucket === "bigkid") return f(n) + "y / " + f(n + 1.5) + "w";
    return f(n); // men (adult bucket): bare men's number — women's labels live in the women's column only
  }
  window.staackedParseSize = staackedParseSize;
  window.staackedSizeLabel = staackedSizeLabel;

  /* size-chart sort: toddler c -> little kid c -> big kid y -> adult -> apparel -> other.
     same bucket walk the size facet uses; within a bucket the canonical men's-scale
     number decides (women = men + 1.5 handled by staackedParseSize). unparseable
     values sort last and keep their relative order. */
  function staackedSortSizes(values) {
    var ORDER = { toddler: 0, littlekid: 1, bigkid: 2, adult: 3, apparel: 4, other: 5 };
    var LETTERS = ["xxs", "xs", "s", "m", "l", "xl", "xxl", "xxxl"];
    return values.map(function (v, i) {
      var p = staackedParseSize(v == null ? "" : String(v));
      var rank = ORDER[p.bucket] == null ? 5 : ORDER[p.bucket];
      var n = p.canon;
      if (n == null && p.bucket === "apparel") {
        var li = LETTERS.indexOf(String(v).toLowerCase().trim());
        if (li >= 0) n = li;
      }
      return { v: v, i: i, rank: rank, n: n };
    }).sort(function (a, b) {
      if (a.rank !== b.rank) return a.rank - b.rank;
      if (a.n != null && b.n != null && a.n !== b.n) return a.n - b.n;
      if (a.n != null && b.n == null) return -1;
      if (a.n == null && b.n != null) return 1;
      return a.i - b.i; // stable
    }).map(function (x) { return x.v; });
  }
  window.staackedSortSizes = staackedSortSizes;

  (function () {
    var sizeFacet = document.querySelector('[data-facet="size"][data-facet-type="list"]');
    if (!sizeFacet) return;
    var panel = sizeFacet.querySelector(".facet-panel");
    if (!panel) return;
    var labels = Array.prototype.slice.call(panel.querySelectorAll("label"));
    if (labels.length < 8) return; // not worth grouping a short list

    var GROUPS = [
      { key: "toddler", name: "toddler (td)" },
      { key: "littlekid", name: "little kid (ps)" },
      { key: "bigkid", name: "big kid (gs)" },
      { key: "adult", name: "men" },
      { key: "womens", name: "women's" }, // built after men so both twin sources exist; DOM-inserted before it
      { key: "apparel", name: "apparel / one-size" },
      { key: "other", name: "other" },
    ];

    // bucket -> canonical size -> [labels]; unparsed labels keep to the side
    var buckets = {};
    labels.forEach(function (lab) {
      var input = lab.querySelector("input");
      var val = input ? input.getAttribute("value") : lab.textContent;
      var p = staackedParseSize(val);
      var bk = (buckets[p.bucket] = buckets[p.bucket] || { canon: {}, loose: [] });
      if (p.canon == null) bk.loose.push(lab);
      else (bk.canon[p.canon] = bk.canon[p.canon] || []).push(lab);
    });

    function countOf(lab) {
      var mt = lab.textContent.match(/\((\d+)\)/);
      return mt ? parseInt(mt[1], 10) : 0;
    }

    var frag = document.createDocumentFragment();
    function emitGroup(name, rows, count, anyActive, beforeNode) {
      var sub = document.createElement("details");
      sub.className = "facet-subgroup";
      // desktop: the full-width panel shows every age group open as side-by-side
      // columns; mobile keeps the collapsed-subgroup drill-down (open = active only)
      if (anyActive || window.matchMedia("(min-width: 761px)").matches) sub.open = true;
      var head = document.createElement("summary");
      head.className = "facet-subhead";
      head.innerHTML = "<span>" + name + "</span><span class='facet-subcount'>" +
        count + (anyActive ? " •" : "") + "</span>";
      sub.appendChild(head);
      var body = document.createElement("div");
      body.className = "facet-subbody";
      rows.forEach(function (r) { body.appendChild(r); });
      sub.appendChild(body);
      if (beforeNode) frag.insertBefore(sub, beforeNode); else frag.appendChild(sub);
      return sub;
    }
    // canonical men's-scale number -> twin-row state for the women's column:
    // big-kid canons 3.5-7 (= 5w-8.5w, youth overlap) and men canons 7.5-11.5
    // (= 9w-13w; owner capped the women's range at 13w)
    var wMirror = {}, adultSub = null;
    var wf = function (x) { return (Math.round(x * 10) / 10).toString().replace(/\.0$/, ""); };
    GROUPS.forEach(function (g) {
      // women's is a mirror column, not a parse bucket: twin rows of big kid (5w-8.5w,
      // the youth overlap) AND men (9w+ = men - 1.5), women's-first labels with the twin
      // system marked ("6w / 4.5y", "10w / 8.5m") — same scope as the header accordion tile
      if (g.key === "womens") {
        var wCanons = Object.keys(wMirror).map(parseFloat).sort(function (a, b) { return a - b; });
        if (!wCanons.length) return;
        var wRows = [], wAny = false;
        wCanons.forEach(function (n) {
          var mr = wMirror[n];
          if (mr.active) wAny = true;
          var row = document.createElement("label");
          var box = document.createElement("input");
          box.type = "checkbox";
          box.checked = mr.active;
          box.addEventListener("change", function () {
            mr.members.forEach(function (lab) {
              var i = lab.querySelector("input");
              if (i) i.checked = box.checked;
            });
            mr.bk.checked = box.checked; // keep the big-kid twin lit
          });
          mr.w = box;
          row.appendChild(box);
          row.appendChild(document.createTextNode(" " + wf(n + 1.5) + "w / " + wf(n) + mr.suf + " (" + mr.total + ")"));
          wRows.push(row);
        });
        emitGroup(g.name, wRows, wCanons.length, wAny, adultSub); // women's column sits before men
        return;
      }
      var bk = buckets[g.key];
      if (!bk) return;
      var canons = Object.keys(bk.canon).map(parseFloat).sort(function (a, b) { return a - b; });
      if (!canons.length && !bk.loose.length) return;

      var rows = [];
      var anyActive = false;
      canons.forEach(function (n) {
        var members = bk.canon[n];
        var total = 0, active = false;
        members.forEach(function (lab) {
          total += countOf(lab);
          var i = lab.querySelector("input");
          if (i && i.checked) active = true;
        });
        if (active) anyActive = true;
        // ONE checkbox per canonical size — dual-system label, toggles every member
        var row = document.createElement("label");
        var box = document.createElement("input");
        box.type = "checkbox";
        box.checked = active;
        var twin = null; // big-kid (3.5y-7y) and men (7.5+) rows get a women's twin row — keep both lit together
        if ((g.key === "bigkid" && n >= 3.5 && n <= 7) || (g.key === "adult" && n >= 7.5 && n <= 11.5))
          twin = wMirror[n] = { members: members, total: total, active: active, bk: box, w: null, suf: g.key === "bigkid" ? "y" : "m" };
        box.addEventListener("change", function () {
          members.forEach(function (lab) {
            var i = lab.querySelector("input");
            if (i) i.checked = box.checked;
          });
          if (twin && twin.w) twin.w.checked = box.checked;
        });
        row.appendChild(box);
        row.appendChild(document.createTextNode(" " + staackedSizeLabel(g.key, n) + " (" + total + ")"));
        rows.push(row);
        // members stay in the form (hidden inputs still submit) as siblings, never nested
        members.forEach(function (lab) { lab.style.display = "none"; rows.push(lab); });
      });
      bk.loose.forEach(function (lab) {
        var i = lab.querySelector("input");
        if (i && i.checked) anyActive = true;
        rows.push(lab);
      });

      var subNode = emitGroup(g.name, rows, canons.length + bk.loose.length, anyActive);
      if (g.key === "adult") adultSub = subNode;
    });
    panel.innerHTML = "";
    panel.appendChild(frag);
    panel.classList.add("facet-panel-grouped");
  })();

  /* ---- homepage size chips: dual-system labels + links carrying every equivalent
     raw value (6Y, 6y, 6Y/7.5W, 7.5W, …) — values that don't exist are harmless. */
  (function () {
    var f = function (x) { return (Math.round(x * 10) / 10).toString().replace(/\.0$/, ""); };
    document.querySelectorAll("[data-size-chip]").forEach(function (a) {
      var n = parseFloat(a.getAttribute("data-n"));
      var track = a.getAttribute("data-track");
      if (isNaN(n) || !track) return;
      var avail = a.getAttribute("data-avail") || "";
      var base = a.getAttribute("href").split("?")[0];
      var s = f(n), w = f(n + 1.5);
      var vals;
      if (track === "c") { vals = [s + "C", s + "c"]; }
      else if (track === "y") {
        vals = [s + "Y", s + "y", s + "Y/" + w + "W", s + "y/" + w + "w", w + "W/" + s + "Y", w + "w/" + s + "y", w + "W", w + "w"];
        a.textContent = s + "y / " + w + "w";
      } else if (track === "w") {
        // women's tile, two twin segments: ≤8.5w = youth overlap (5w=3.5y … 8.5w=7y),
        // 9w+ = men - 1.5 (9w=7.5m …); SAME equivalence sets as the twin tracks so
        // one tap matches every labelling style
        var eq = f(n - 1.5);
        if (n <= 8.5) {
          vals = [eq + "Y", eq + "y", eq + "Y/" + s + "W", eq + "y/" + s + "w", s + "W/" + eq + "Y", s + "w/" + eq + "y", s + "W", s + "w"];
          a.textContent = s + "w / " + eq + "y";
        } else {
          vals = [eq, eq + "M", eq + "m", eq + "M/" + s + "W", eq + "m/" + s + "w", s + "W/" + eq + "M", s + "w/" + eq + "m", s + "W", s + "w"];
          a.textContent = s + "w / " + eq + "m";
        }
      } else {
        // men tile: bare men's number label; vals still carry the women's raw forms
        // (both combo orders) so listings typed as "10.5W" or "10.5W/9M" keep matching
        vals = [s, s + "M", s + "m", s + "M/" + w + "W", s + "m/" + w + "w", w + "W/" + s + "M", w + "w/" + s + "m", w + "W", w + "w"];
        a.textContent = s;
      }
      var q = vals.map(function (v) { return "filter.v.option.size=" + encodeURIComponent(v); }).join("&");
      a.setAttribute("href", base + "?" + q + avail);
    });

    /* upgrade pass: the catalog feed's `sizes` is the REAL raw-value inventory
       (collected by the sweep). Union each chip's link with the matching real
       values so brand-quirk combos the static guess can't enumerate ("10W/9M",
       "5Y/6W") still match. The guessed list above stays as the baseline and
       the whole fallback when the feed is unreachable or not yet populated. */
    function upgradeChips(sizes) {
      if (!sizes || !sizes.length) return;
      document.querySelectorAll("[data-size-chip]").forEach(function (a) {
        var n = parseFloat(a.getAttribute("data-n"));
        var track = a.getAttribute("data-track");
        if (isNaN(n) || !track) return;
        var avail = a.getAttribute("data-avail") || "";
        var base = a.getAttribute("href").split("?")[0];
        var canon = track === "w" ? n - 1.5 : n; // women's chips live on the men's scale
        var extra = sizes.filter(function (v) {
          var p = staackedParseSize(v);
          if (p.canon !== canon) return false;
          if (track === "c") return p.bucket === "toddler" || p.bucket === "littlekid";
          if (track === "y") return p.bucket === "bigkid";
          if (track === "w") return p.bucket === (n <= 8.5 ? "bigkid" : "adult");
          return p.bucket === "adult";
        });
        if (!extra.length) return;
        var cur = (a.getAttribute("href").split("?")[1] || "").split("&")
          .filter(function (kv) { return kv.indexOf("filter.v.option.size=") === 0; })
          .map(function (kv) { return decodeURIComponent(kv.slice(21)); });
        var seen = {}, merged = [];
        cur.concat(extra).forEach(function (v) { if (!seen[v]) { seen[v] = 1; merged.push(v); } });
        var q = merged.map(function (v) { return "filter.v.option.size=" + encodeURIComponent(v); }).join("&");
        a.setAttribute("href", base + "?" + q + avail);
      });
    }
    try {
      var FEED = "https://staacked-catalog.netlify.app"; // same service the brand tiles use
      var cachedSizes = sessionStorage.getItem("st-sizes"); // one fetch per visitor session, not per page
      if (cachedSizes) upgradeChips(JSON.parse(cachedSizes));
      else fetch(FEED + "/feed", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var sizes = (d && d.sizes) || [];
          try { sessionStorage.setItem("st-sizes", JSON.stringify(sizes)); } catch (e) { /* private mode */ }
          upgradeChips(sizes);
        })
        .catch(function () { /* guessed hrefs stay */ });
    } catch (e) { /* guessed hrefs stay */ }
  })();

  /* ---- brand facet: merge duplicate vendor casings into one row ----
     the catalog has Adidas/adidas and HOKA/Hoka One One as separate vendors;
     merge each pair into a single checkbox that filters on both values.
     (Phase 2's metafield service normalizes brand at the source; this is the
     no-service stopgap so the live facet reads clean now.) */
  (function () {
    var brandFacet = document.querySelector('[data-facet="brand"][data-facet-type="list"]');
    if (!brandFacet) return;
    var bpanel = brandFacet.querySelector(".facet-panel");
    if (!bpanel) return;
    // AUTO case-fold FIRST: merge any vendor rows whose values differ only by
    // casing (Adidas/adidas today; ANY future brand's casing variants without
    // touching this file). One checkbox toggles every member input; the form's
    // change handler submits with the real raw values, so filtering matches all
    // spellings. The MERGES list below then only handles true word aliases.
    var byFold = {};
    Array.prototype.slice.call(bpanel.querySelectorAll("label")).forEach(function (lab) {
      var i = lab.querySelector("input");
      if (!i || lab.style.display === "none") return;
      var key = (i.getAttribute("value") || "").trim().toLowerCase();
      if (key) (byFold[key] = byFold[key] || []).push(lab);
    });
    Object.keys(byFold).forEach(function (key) {
      var members = byFold[key];
      if (members.length < 2) return;
      var total = 0, anyActive = false;
      members.forEach(function (lab) {
        var mt = lab.textContent.match(/\((\d+)\)/);
        if (mt) total += parseInt(mt[1], 10);
        var i = lab.querySelector("input");
        if (i && i.checked) anyActive = true;
      });
      var row = document.createElement("label");
      var box = document.createElement("input");
      box.type = "checkbox";
      box.checked = anyActive;
      box.addEventListener("change", function () {
        members.forEach(function (lab) {
          var i = lab.querySelector("input");
          if (i) i.checked = box.checked;
        });
      });
      row.appendChild(box);
      row.appendChild(document.createTextNode(" " + key + " (" + total + ")"));
      members[0].parentNode.insertBefore(row, members[0]);
      members.forEach(function (lab) { lab.style.display = "none"; });
    });

    var MERGES = [
      { label: "adidas", values: ["Adidas", "adidas"] },
      { label: "hoka", values: ["HOKA", "Hoka One One"] },
    ];
    MERGES.forEach(function (m) {
      var members = Array.prototype.slice.call(bpanel.querySelectorAll("label")).filter(function (lab) {
        var i = lab.querySelector("input");
        // skip rows the case-fold pass above already merged away, or adidas
        // would get merged twice (two identical rows)
        return i && lab.style.display !== "none" && m.values.indexOf(i.getAttribute("value")) !== -1;
      });
      if (members.length < 2) return;
      var total = 0, anyActive = false;
      members.forEach(function (lab) {
        var mt = lab.textContent.match(/\((\d+)\)/);
        if (mt) total += parseInt(mt[1], 10);
        var i = lab.querySelector("input");
        if (i && i.checked) anyActive = true;
      });
      // build one merged row; toggling it toggles both underlying inputs, then the
      // form's own change handler submits (member inputs carry the real values).
      var row = document.createElement("label");
      var box = document.createElement("input");
      box.type = "checkbox";
      box.checked = anyActive;
      box.addEventListener("change", function () {
        members.forEach(function (lab) {
          var i = lab.querySelector("input");
          if (i) i.checked = box.checked;
        });
      });
      row.appendChild(box);
      row.appendChild(document.createTextNode(" " + m.label + " (" + total + ")"));
      members[0].parentNode.insertBefore(row, members[0]);
      members.forEach(function (lab) { lab.style.display = "none"; });
    });

    // order brands by stock (the "(N)" facet counts), most first — not alphabetically
    var rows = Array.prototype.slice.call(bpanel.querySelectorAll("label")).filter(function (l) {
      return l.style.display !== "none";
    });
    rows.sort(function (a, b) {
      var ca = parseInt((a.textContent.match(/\((\d+)\)/) || [0, 0])[1], 10) || 0;
      var cb = parseInt((b.textContent.match(/\((\d+)\)/) || [0, 0])[1], 10) || 0;
      return cb - ca;
    });
    rows.forEach(function (l) { bpanel.appendChild(l); });
  })();

  /* ---- product page: variant picker ---- */
  var pdp = document.querySelector("[data-pdp]");
  if (pdp) {
    var variantsTag = document.getElementById("pdp-variants");
    var variants = [];
    try { variants = JSON.parse(variantsTag.textContent); } catch (err) {}

    // size swatches render in admin entry order — reorder into size-chart order.
    // appendChild moves the existing nodes, so the click listeners attached below
    // (per-button) are unaffected whichever runs first.
    pdp.querySelectorAll("[data-size-opt] .swatches").forEach(function (wrap) {
      var btns = Array.prototype.slice.call(wrap.querySelectorAll("[data-swatch]"));
      if (btns.length < 2) return;
      var pos = {};
      staackedSortSizes(btns.map(function (b) { return b.getAttribute("data-opt-value"); }))
        .forEach(function (v, i) { if (pos[v] == null) pos[v] = i; });
      btns.map(function (b, i) { return { b: b, k: pos[b.getAttribute("data-opt-value")], i: i }; })
        .sort(function (a, b) { return (a.k - b.k) || (a.i - b.i); })
        .forEach(function (x) { wrap.appendChild(x.b); });
    });

    var selected = {}; // optionName -> value
    var idInput = pdp.querySelector("[data-variant-id]");
    var priceEl = pdp.querySelector("[data-price]");
    var addBtn = pdp.querySelector("[data-add]");

    // init from first available variant
    var first = variants.find(function (v) { return v.available; }) || variants[0];
    if (first) { first.options.forEach(function (val, i) { selected["opt" + i] = val; }); }

    function money(cents) {
      return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    }

    function matchVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return selected["opt" + i] === val; });
      });
    }

    function render() {
      pdp.querySelectorAll("[data-swatch]").forEach(function (btn) {
        var i = btn.getAttribute("data-opt-index");
        var val = btn.getAttribute("data-opt-value");
        btn.classList.toggle("is-active", selected["opt" + i] === val);
      });
      var v = matchVariant();
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? "add to cart" : "sold out";
        }
      } else if (addBtn) {
        addBtn.disabled = true; addBtn.textContent = "unavailable";
      }
    }

    pdp.querySelectorAll("[data-swatch]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-sold")) return;
        var i = btn.getAttribute("data-opt-index");
        selected["opt" + i] = btn.getAttribute("data-opt-value");
        render();
      });
    });
    render();
  }

  /* ---- card quick-add: size chips -> lid choice (when the product has one) -> price -> add ----
     every product card embeds its variants as JSON; pick a size right on the card, choose
     with/without lid if that axis exists, and add to cart without opening the product page. */
  (function () {
    var cards = document.querySelectorAll("[data-quick-add]");
    if (!cards.length) return;
    function money(cents) { var n = cents / 100; return "$" + (n % 1 ? n.toFixed(2) : String(n)); }
    function lidLabel(v) {
      var s = (v || "").toLowerCase();
      if (/full|complete|with|good|og all/.test(s)) return "with lid";
      if (/missing|no lid|without|damag|lidless/.test(s)) return "without lid";
      return (v || "").toLowerCase();
    }
    function chip(cls, text) {
      var b = document.createElement("button");
      b.type = "button"; b.className = cls; b.textContent = text;
      return b;
    }

    cards.forEach(function (card) {
      var tag = card.querySelector("[data-pc-data]");
      if (!tag) return;
      var data = null;
      try { data = JSON.parse(tag.textContent); } catch (err) { return; }
      var variants = data.variants || [];
      if (!variants.length) return;
      var names = (data.names || []).map(function (n) { return (n || "").toLowerCase(); });
      var sizeIdx = -1, boxIdx = -1;
      names.forEach(function (n, i) {
        if (n.indexOf("size") >= 0 && sizeIdx < 0) sizeIdx = i;
        else if (n.indexOf("box") >= 0 || n.indexOf("condition") >= 0 || n.indexOf("lid") >= 0) boxIdx = i;
      });
      if (sizeIdx < 0 && names.length === 1) sizeIdx = 0;

      var buy = card.querySelector(".pc-buy");
      var sizesEl = card.querySelector("[data-pc-sizes]");
      var lidsEl = card.querySelector("[data-pc-lids]");
      var statusEl = card.querySelector("[data-pc-status]");
      var addBtn = card.querySelector("[data-pc-add]");
      var priceEl = card.querySelector("[data-pc-price]");
      var fallback = card.querySelector("[data-pc-fallback]");
      var sel = { size: null, box: null, variant: null };

      function boxValsFor(size) {
        var vals = [];
        variants.forEach(function (v) {
          if (size != null && v.options[sizeIdx] !== size) return;
          var bv = v.options[boxIdx];
          if (bv != null && vals.indexOf(bv) < 0) vals.push(bv);
        });
        return vals;
      }
      function resolve() {
        return variants.filter(function (v) {
          if (sizeIdx >= 0 && sel.size != null && v.options[sizeIdx] !== sel.size) return false;
          if (boxIdx >= 0 && sel.box != null && v.options[boxIdx] !== sel.box) return false;
          return v.available;
        })[0] || null;
      }
      function showResolved() {
        var v = resolve();
        sel.variant = v;
        if (v) {
          if (priceEl) priceEl.textContent = money(v.price);
          addBtn.hidden = false; addBtn.disabled = false; addBtn.textContent = "add to cart";
        } else {
          addBtn.hidden = false; addBtn.disabled = true; addBtn.textContent = "unavailable";
        }
      }
      function renderLids() {
        lidsEl.innerHTML = ""; lidsEl.hidden = true;
        addBtn.hidden = true; sel.box = null; sel.variant = null;
        if (boxIdx < 0) { showResolved(); return; }
        var all = boxValsFor(null);
        if (all.length < 2) { showResolved(); return; } // single box value catalog-wide: nothing to choose
        var avail = all.filter(function (bv) {
          return variants.some(function (v) {
            return v.options[boxIdx] === bv && v.available && (sel.size == null || v.options[sizeIdx] === sel.size);
          });
        });
        lidsEl.hidden = false;
        // in-stock lid options only (user: never show unavailable choices on cards)
        avail.forEach(function (bv) {
          var b = chip("mc-lid", lidLabel(bv));
          b.addEventListener("click", function () {
            sel.box = bv;
            lidsEl.querySelectorAll(".mc-lid").forEach(function (x) { x.classList.remove("is-active"); });
            b.classList.add("is-active");
            showResolved();
          });
          lidsEl.appendChild(b);
        });
        // only one combo in stock for this size -> pre-select it so price + add show right away
        if (avail.length === 1) {
          sel.box = avail[0];
          var pre = Array.prototype.slice.call(lidsEl.querySelectorAll(".mc-lid")).filter(function (x) { return x.textContent === lidLabel(avail[0]); })[0];
          if (pre) pre.classList.add("is-active");
          showResolved();
        }
      }

      // size chips (or straight to add for one-size products)
      if (sizeIdx >= 0) {
        var seen = {}, list = [];
        variants.forEach(function (v) {
          var sz = v.options[sizeIdx];
          if (sz == null || seen[sz]) return; seen[sz] = 1;
          var ok = variants.some(function (w) { return w.options[sizeIdx] === sz && w.available; });
          list.push({ sz: sz, ok: ok });
        });
        // size-chart order via the shared comparator (toddler -> kid -> adult; w = m + 1.5)
        var pos = {};
        staackedSortSizes(list.map(function (it) { return it.sz; }))
          .forEach(function (v, i) { if (pos[v] == null) pos[v] = i; });
        list.sort(function (a, b) { return pos[a.sz] - pos[b.sz]; });
        // in-stock sizes only (user: don't show sold-out sizes on cards)
        list.filter(function (it) { return it.ok; }).forEach(function (it) {
          var b = chip("mc-size", String(it.sz).toLowerCase());
          b.addEventListener("click", function () {
            sel.size = it.sz;
            sizesEl.querySelectorAll(".mc-size").forEach(function (x) { x.classList.remove("is-active"); });
            b.classList.add("is-active");
            statusEl.textContent = "";
            renderLids();
          });
          sizesEl.appendChild(b);
        });
      } else {
        renderLids(); // one-size: still offer the lid choice if that axis exists, else straight to add
      }

      addBtn.addEventListener("click", function () {
        if (!sel.variant) return;
        addBtn.disabled = true; addBtn.textContent = "adding…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: sel.variant.id, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            addBtn.textContent = "added ✓";
            statusEl.innerHTML = '<a href="/cart">view cart →</a>';
            if (window.staackedRefreshCart) window.staackedRefreshCart();
            setTimeout(function () { addBtn.disabled = false; addBtn.textContent = "add to cart"; }, 1800);
          })
          .catch(function (err) {
            if (err && err.status === 422) {
              // variant sold between page render and the tap — flip to the sold state
              addBtn.disabled = true; addBtn.textContent = "sold out";
              statusEl.textContent = "sold — someone beat you to it";
            } else {
              addBtn.disabled = false; addBtn.textContent = "try again";
              statusEl.textContent = "couldn't add — tap try again";
            }
          });
      });

      if (fallback) fallback.hidden = true;
      buy.hidden = false;
    });
  })();

  /* ---- shop-by-brand tiles: re-order live by in-stock rank from the catalog feed ---- */
  (function () {
    var bg = document.querySelector("[data-brand-grid]");
    if (!bg) return;
    var base = (bg.getAttribute("data-feed") || "").replace(/\/$/, "");
    var coll = bg.getAttribute("data-coll") || "/collections/all";
    var avail = bg.getAttribute("data-avail") || "";
    // brands whose vendor value isn't just the name (casing splits / multi-word)
    var VENDOR = { "adidas": "Adidas&filter.p.vendor=adidas", "New Balance": "New+Balance", "HOKA": "Hoka+One+One", "The North Face": "The+North+Face", "Denim Tears": "Denim+Tears", "Onitsuka Tiger": "Onitsuka+Tiger" };
    function vendorParam(b) { return VENDOR[b] || encodeURIComponent(b); }
    // brand -> logo asset map (rendered by Liquid; brands without a file show as text)
    var logos = {};
    var lmTag = document.querySelector("[data-brand-logo-map]");
    if (lmTag) { try { logos = JSON.parse(lmTag.textContent); } catch (err) {} }

    fetch(base + "/feed", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var brands = (data.brands || []).filter(function (x) { return x.count > 0; }).slice(0, 8);
        if (!brands.length) return; // keep the static fallback
        bg.innerHTML = brands.map(function (x) {
          var lb = String(x.brand).toLowerCase();
          var inner = logos[lb] ? '<img src="' + logos[lb] + '" alt="' + lb + '" loading="lazy">' : lb;
          // the feed carries every RAW vendor spelling behind a brand (casing
          // variants) — filter on all of them so merged brands never lose items;
          // vendorParam stays as the fallback for old feed payloads
          var params = (x.vendors && x.vendors.length ? x.vendors : null);
          var qs = params
            ? params.map(function (v) { return "filter.p.vendor=" + encodeURIComponent(v); }).join("&")
            : "filter.p.vendor=" + vendorParam(x.brand);
          return '<a class="brand-tile" href="' + coll + "?" + qs + avail + '" aria-label="' + lb + '">' + inner + "</a>";
        }).join("");
      })
      .catch(function () { /* leave the static fallback in place */ });
  })();

  /* ---- category facet: shopper-facing buckets sneakers / slides / clothing / accessories.
     Search & Discovery's "Category" filter (Product type source) natively groups the shoe
     types into "Sneakers"; this pass renames apparel -> clothing, hides the Insurance
     service-product type, fixes the bucket order, and folds any NEW raw types the brother
     adds later (Backpack, Boots, …) into the right bucket — one checkbox toggles all its
     member inputs, same pattern as the brand-casing merge. ---- */
  (function () {
    var typeFacet = document.querySelector('[data-facet="category"][data-facet-type="list"], [data-facet="product type"][data-facet-type="list"]');
    if (!typeFacet) return;
    var panel = typeFacet.querySelector(".facet-panel");
    if (!panel) return;
    // header reads "category" even if the filter label is still "Product type"
    var summary = typeFacet.querySelector("summary");
    if (summary && summary.firstChild && summary.firstChild.nodeType === 3) summary.firstChild.textContent = "category ";

    function classify(raw) {
      var v = (raw || "").toLowerCase();
      if (/insurance|protection|warranty/.test(v)) return "hide"; // service SKUs, not a shopper category
      if (/slide|sandal|flip[- ]?flop|clog|slipper/.test(v)) return "slides";
      if (/shoe|sneaker|trainer|runner|boot|footwear|slip[- ]?on/.test(v)) return "sneakers";
      if (/apparel|cloth|tee|t-shirt|shirt|hoodie|sweat|short|pant|jacket|sock/.test(v)) return "clothing";
      return "accessories";
    }
    var ORDER = ["sneakers", "slides", "clothing", "accessories"];
    var groups = {};
    Array.prototype.slice.call(panel.querySelectorAll("label")).forEach(function (lab) {
      var input = lab.querySelector("input");
      if (!input) return;
      // classify on label text + raw value — a native S&D group's input value is an opaque
      // token, so the visible label ("sneakers (297)") is the reliable signal
      var g = classify((input.getAttribute("value") || "") + " " + lab.textContent);
      if (g === "hide") { lab.style.display = "none"; return; }
      (groups[g] = groups[g] || []).push(lab);
    });

    ORDER.forEach(function (g) {
      var members = groups[g];
      if (!members || !members.length) return;
      var total = 0, anyActive = false;
      members.forEach(function (lab) {
        var mt = lab.textContent.match(/\((\d+)\)/);
        if (mt) total += parseInt(mt[1], 10);
        var i = lab.querySelector("input");
        if (i && i.checked) anyActive = true;
      });
      var row = document.createElement("label");
      var box = document.createElement("input");
      box.type = "checkbox";
      box.checked = anyActive;
      box.addEventListener("change", function () {
        members.forEach(function (lab) {
          var i = lab.querySelector("input");
          if (i) i.checked = box.checked;
        });
      });
      row.appendChild(box);
      row.appendChild(document.createTextNode(" " + g + " (" + total + ")"));
      panel.appendChild(row);
      members.forEach(function (lab) { lab.style.display = "none"; });
    });
  })();

  /* ---- live cart count refresh (after add) ---- */
  window.staackedRefreshCart = function () {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var c = document.querySelector("[data-cart-count]");
        if (c) c.textContent = cart.item_count;
      })
      .catch(function () {});
  };
})();

/* ---- live status: reads the flag your portal flips when you go live ----
   JSON shape: { live, tiktok, whatnot, tt_yt_id, wn_yt_id, whatnot_show_url, next_show }
   (a bare { live: true } still works for the site-wide hooks) */
(function(){
  function setLive(wn, tt){
    var on = !!(wn || tt);
    // live bar: reveal only the platform(s) actually live, each with its own red dot
    document.querySelectorAll('[data-live-bar]').forEach(function(bar){
      bar.classList.toggle('on', on);
      var t = bar.querySelector('[data-lb-plat="tiktok"]'); if(t) t.style.display = tt ? '' : 'none';
      var w = bar.querySelector('[data-lb-plat="whatnot"]'); if(w) w.style.display = wn ? '' : 'none';
    });
    document.querySelectorAll('[data-hero-live]').forEach(function(e){ e.classList.toggle('on', on); });
    document.querySelectorAll('[data-live-only]').forEach(function(e){ e.style.display = on ? '' : 'none'; });
    // floating buttons carry ALL live status: black brand-accented buttons when
    // offline, FULL brand color + blinking dot + "— live now" when live. the live tag
    // is its own hidden-toggled span — never rewrite the label's textContent, that
    // would erase the inline platform icon next to it.
    document.querySelectorAll('[data-live-fab]').forEach(function(e){ e.classList.toggle('live', tt); });
    var fl = document.querySelector('[data-tt-live-tag]'); if(fl) fl.hidden = !tt;
    document.querySelectorAll('[data-wn-fab]').forEach(function(e){ e.classList.toggle('live', wn); });
    var wl = document.querySelector('[data-wn-live-tag]'); if(wl) wl.hidden = !wn;
  }

  var hub = document.querySelector('[data-live-hub]');

  function ytSrc(id, muted){
    return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
      '?autoplay=1&mute=' + (muted ? 1 : 0) +
      '&controls=0&playsinline=1&rel=0&iv_load_policy=3&disablekb=1&fs=0';
  }
  function ttSrc(handle, muted){
    return 'https://www.tiktok.com/embed/live/' + encodeURIComponent(handle) +
      '?autoplay=1&muted=' + (muted ? 1 : 0) +
      '&controls=0&embed_domain=' + encodeURIComponent(location.hostname);
  }

  function clearMedia(tile){
    tile.querySelectorAll('.lh-media iframe, .lh-media video').forEach(function(n){ n.remove(); });
    var snd = tile.querySelector('[data-lh-sound]');
    if(snd){ snd.hidden = true; }
    tile.classList.remove('is-live');
  }

  // builds the best available media for a live tile; muted unless the user tapped sound on
  function buildMedia(tile, plat, d, muted){
    clearMedia(tile);
    tile.classList.add('is-live');
    var media = tile.querySelector('[data-lh-media]');
    var ytId = plat === 'whatnot' ? d.wn_yt_id : d.tt_yt_id;
    var el = null;
    if(ytId){
      el = document.createElement('iframe');
      el.src = ytSrc(ytId, muted);
      el.allow = 'autoplay; encrypted-media';
      el.title = plat + ' live stream';
    } else if(plat === 'tiktok' && hub.getAttribute('data-tt-embed') === '1' && hub.getAttribute('data-tt-handle')){
      el = document.createElement('iframe');
      el.src = ttSrc(hub.getAttribute('data-tt-handle'), muted);
      el.allow = 'autoplay; encrypted-media';
      el.title = 'tiktok live stream';
    } else if(tile.getAttribute('data-preview')){
      el = document.createElement('video');
      el.src = tile.getAttribute('data-preview');
      el.muted = true; el.loop = true; el.autoplay = true; el.playsInline = true;
      el.setAttribute('muted', ''); el.setAttribute('playsinline', '');
      if(tile.getAttribute('data-poster')) el.poster = tile.getAttribute('data-poster');
    }
    if(el) media.appendChild(el);
    // sound toggle only when a real stream embed is playing
    var snd = tile.querySelector('[data-lh-sound]');
    if(snd && el && el.tagName === 'IFRAME'){
      snd.hidden = muted === false;
      snd.onclick = function(ev){
        ev.preventDefault(); ev.stopPropagation();
        // mute any other tile, rebuild this one with sound (user gesture allows it)
        hub.querySelectorAll('[data-lh-tile].is-live').forEach(function(other){
          if(other !== tile && other.querySelector('iframe')){
            buildMedia(other, other.getAttribute('data-lh-tile'), lastData, true);
          }
        });
        buildMedia(tile, plat, d, false);
      };
    }
  }

  var lastData = null;
  function renderHub(d){
    if(!hub) return;
    lastData = d;
    var wn = !!d.whatnot, tt = !!d.tiktok;
    var state = wn && tt ? 'both' : wn ? 'wn' : tt ? 'tt' : 'none';
    hub.setAttribute('data-state', state);
    hub.querySelectorAll('[data-lh-tile]').forEach(function(tile){
      var plat = tile.getAttribute('data-lh-tile');
      var live = plat === 'whatnot' ? wn : tt;
      if(live){
        if(plat === 'whatnot' && d.whatnot_show_url){
          var a = tile.querySelector('[data-lh-link]'); if(a) a.href = d.whatnot_show_url;
        }
        buildMedia(tile, plat, d, true);
      } else {
        clearMedia(tile);
      }
    });
    var next = hub.querySelector('[data-lh-next]');
    if(next){
      var txt = d.next_show && (d.next_show.text || d.next_show);
      if(typeof txt === 'string' && txt.trim()){ next.textContent = 'next show: ' + txt; next.hidden = false; }
      else { next.hidden = true; }
    }
  }

  function refresh(){
    var cfg = window.STAACKED_LIVE || {};
    if(!cfg.statusUrl){ setLive(false, false); renderHub({}); return; }
    fetch(cfg.statusUrl, { cache:'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(d){
        d = d || {};
        var wn = d.whatnot !== undefined ? !!d.whatnot : !!d.live;
        var tt = d.tiktok !== undefined ? !!d.tiktok : !!d.live;
        d.whatnot = wn; d.tiktok = tt;
        setLive(wn, tt);
        renderHub(d);
      })
      .catch(function(){ setLive(false, false); renderHub({}); });
  }

  setLive(false, false); // default offline until the flag says otherwise
  renderHub({});
  refresh();
  setInterval(function(){ if(!document.hidden) refresh(); }, 60000);
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) refresh(); });
})();

/* ---- tiktok popup: lazy-loads TikTok embed.js only when first opened ---- */
(function(){
  var modal = document.querySelector('[data-tt-modal]');
  var openers = document.querySelectorAll('[data-tt-open]');
  if(!modal || !openers.length) return;
  var loaded = false;
  function open(){
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if(!loaded){
      var s = document.createElement('script');
      s.async = true; s.src = 'https://www.tiktok.com/embed.js';
      document.body.appendChild(s);
      loaded = true;
    }
  }
  function close(){ modal.hidden = true; document.body.style.overflow = ''; }
  openers.forEach(function(b){ b.addEventListener('click', open); });
  modal.querySelectorAll('[data-tt-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !modal.hidden) close(); });
})();

/* route shipping protection: hidden from all product grids, auto-added to the cart
   (on by default). tier = the available variant priced nearest 2% of the real-items
   subtotal (route's own pricing curve), floor $0.98. removing it on the cart page is
   remembered (localStorage) until the cart empties — then a fresh order defaults on. */
(function () {
  "use strict";
  var HANDLE = "routeins";
  var OPTOUT = "route_optout";
  var busy = false;

  function isRoute(item) { return (item.vendor || "") === "Route" || item.handle === HANDLE; }

  function change(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var real = cart.items.filter(function (i) { return !isRoute(i); });
      var route = cart.items.filter(isRoute)[0];

      if (!real.length) {
        localStorage.removeItem(OPTOUT); // empty cart -> next order defaults back on
        if (route) return change(route.key, 0).then(function () { done(true); });
        return done(false);
      }
      if (localStorage.getItem(OPTOUT)) return done(false);

      var subtotal = real.reduce(function (s, i) { return s + i.final_line_price; }, 0); // cents
      var target = Math.max(98, Math.round(subtotal * 0.02));

      fetch("/products/" + HANDLE + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return done(false);
        var best = null;
        (p.variants || []).forEach(function (v) {
          if (v.available === false) return;
          if (!best || Math.abs(v.price - target) < Math.abs(best.price - target)) best = v;
        });
        if (!best || (route && route.variant_id === best.id)) return done(false);
        var step = route ? change(route.key, 0) : Promise.resolve();
        step.then(function () {
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: best.id, quantity: 1 }] })
          });
        }).then(function () { done(true); }).catch(function () { done(false); });
      }).catch(function () { done(false); });
    }).catch(function () { busy = false; });

    function done(changed) {
      busy = false;
      if (!changed) return;
      if (document.body.classList.contains("template-cart")) location.reload();
      else if (window.staackedRefreshCart) window.staackedRefreshCart();
    }
  }

  // removing protection on the cart page = deliberate opt-out for this order
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-route-remove]")) localStorage.setItem(OPTOUT, "1");
  });

  // run on load, and after any cart mutation the theme performs
  var prevRefresh = window.staackedRefreshCart;
  window.staackedRefreshCart = function () {
    if (prevRefresh) prevRefresh();
    setTimeout(sync, 400);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sync);
  else sync();
})();

/* image normalization: metafield-driven. data-facing="right" mirrors to the
   canonical LEFT (a mirrored right shoe is the pair's left shoe); data-imgbox
   "l,t,r,b" (fractions) scales + translates confident white-background shots so
   every sole sits on a shared baseline. no data -> untouched. sets --norm so the
   hover zoom composes cleanly on top. */
(function () {
  "use strict";
  var TARGET_BOTTOM = 0.86; // sole baseline: fraction of container height
  var TARGET_SPAN = 0.82;   // max fraction of container the shoe may occupy
  var MAX_SCALE = 1.5, MIN_SCALE = 0.55;

  function apply(img) {
    var facing = img.getAttribute("data-facing");
    var mirror = facing === "right";
    var raw = (img.getAttribute("data-imgbox") || "").split(",").map(parseFloat);
    var hasBox = raw.length === 4 && raw.every(function (n) { return isFinite(n) && n >= 0 && n <= 1; }) && raw[2] > raw[0] && raw[3] > raw[1];

    function set() {
      if (!hasBox) {
        if (mirror) img.style.setProperty("--norm", "scaleX(-1)");
        return;
      }
      var cs = getComputedStyle(img);
      var padX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
      var padY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
      var cw = img.clientWidth - padX, ch = img.clientHeight - padY;
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!cw || !ch || !nw || !nh) return;
      // object-fit: contain geometry inside the content box
      var k = Math.min(cw / nw, ch / nh), dw = nw * k, dh = nh * k;
      var ox = parseFloat(cs.paddingLeft) + (cw - dw) / 2;
      var oy = parseFloat(cs.paddingTop) + (ch - dh) / 2;
      var l = raw[0], t = raw[1], r = raw[2], b = raw[3];
      var shoeW = (r - l) * dw, shoeH = (b - t) * dh;
      var s = Math.min((TARGET_SPAN * cw) / shoeW, (TARGET_SPAN * ch) / shoeH, MAX_SCALE);
      if (s < MIN_SCALE) { if (mirror) img.style.setProperty("--norm", "scaleX(-1)"); return; }
      // element box (incl. padding) centers; transform = translate(tx,ty) scale(sx,s)
      var ew = img.clientWidth, eh = img.clientHeight;
      var ecx = ew / 2, ecy = eh / 2;
      var cx = ox + ((l + r) / 2) * dw;        // shoe horizontal center
      var cyb = oy + b * dh;                    // shoe sole line
      var tx = (mirror ? 1 : -1) * (cx - ecx) * s;
      var ty = eh * TARGET_BOTTOM - ecy - (cyb - ecy) * s;
      img.style.setProperty("--norm", "translate(" + tx.toFixed(1) + "px," + ty.toFixed(1) + "px) scale(" + (mirror ? -s : s).toFixed(3) + "," + s.toFixed(3) + ")");
    }

    if (img.complete && img.naturalWidth) set();
    else img.addEventListener("load", set, { once: true });
    return set;
  }

  var setters = [];
  document.querySelectorAll(".product-card .media img[data-facing], .product-card .media img[data-imgbox]").forEach(function (img) {
    var s = apply(img); if (s) setters.push(s);
  });
  if (setters.length) {
    var t0;
    window.addEventListener("resize", function () {
      clearTimeout(t0);
      t0 = setTimeout(function () { setters.forEach(function (s) { s(); }); }, 180);
    });
  }
})();
